import React, { useEffect } from 'react';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import Body from '../body/Booking';
import Hero from '../hero/hero';
import BreadCrumb from '../utility/breadCrumb';

function Index() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <BreadCrumb
        linkto="Booking"
        linkname="Booking a Lesson"
        linklevel="1"
        linktoone=""
        linknameone=""
        linktotwo=""
        linknametwo=""
      />
      <Hero
        paddingTop = "0px"
        id="9"
        contentId = "9"
        height="300"
        gradient="true"
        gradientDirection="to right"
        gradientRgba="rgba(0,0,0,1) 73%, transparent"
        backgroundSize="auto 100%"
        backgroundRepeat="no-repeat"
        backgroundColor="#000"
        backgroundPosition="right"
        borderwidth="0"
        bordercolor="#FFF"
        bordertype="solid"
        maxWidth="1400px"
        margin="auto"
      />
      <Body id="10" />
      <div
        className="calendly-inline-widget"
        data-url="https://calendly.com/mark-grainger-uclv/30-minute-guitar-lesson?hide_event_type_details=1"
        style={{ minWidth: '320px', height: '700px' }}
      />
    </>
  );
}

export default Index;
